import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {BULL_CALL, MONEYNESS} from "../MarginQuizQuestions";

export const Moneyness = "tfMoneynessQuestion";

export function moneyness() {
    return {
        templateUrl: "app/quiz/margin/questions/Moneyness.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: MoneynessController
    };
}

export class MoneynessController extends MarginQuizQuestionController {
    public config = MONEYNESS;
}
